export const STORAGE_KEYS = {
    ACCESS_TOKEN:"ACCESS_TOKEN",
    USER_DATA:"userData",
    USER_LOGGED_IN:"USER_LOGGED_IN"
    }

